export const Style = `
#numeric_summary_table {
  width : 100%;
  border-collapse: collapse;
}

#numeric_summary_table td {
  vertical-align: bottom;
}

#numeric_summary_table .td-partial-border {
  padding: 10px;
  padding-bottom: 0px;
}

#numeric_summary_table .td-partial-border p {
  border-bottom: 1px solid black;
}

.odd-row {
    background: #ebebeb;
}

.border_column { border-right: #000000 1px solid;padding: 0px;margin: 0px;vertical-align: bottom;}`;

export const Title = `Numeric Summary and Signature Page`;
export const NumericSummaryTableHtml = {
  Table: `
        <div>
            <table id="numeric_summary_table" class="full-width, p-right" cellspacing=0>
              <tr height=12px>
                <td colspan="4"></td>
                <td colspan="4" class="td-partial-border">
                  <p class="p-center">Non-Guaranteed Values</p>
                </td>
              </tr>
              <tr height=12px>
                <td colspan="2"></td>
                <td colspan="2" class="td-partial-border"><p class="p-center">Guaranteed Values</p></td>
                <td colspan="2" class="td-partial-border"><p class="p-center">Midpoint Assumptions</p></td>
                <td colspan="2" class="td-partial-border"><p class="p-center">Current Assumptions</p></td>
              </tr>
              <tr height=20px>
                <td class="border_column"><p>&nbsp;</p></td>
                <td class="border_column"><p>&nbsp;</p></td>
                <td colspan="2" class="border_column"><p>&nbsp;</p></td>
                <td colspan="2" class="border_column"><p>&nbsp;</p></td>
                <td colspan="2" class="border_column"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td class="border_column"><p>&nbsp;</p></td>
                <td class="border_column"><p>&nbsp;</p></td>
                <td><p>Total</p></td>
                <td class="border_column"><p>&nbsp;</p></td>
                <td><p>Total</p></td>
                <td class="border_column"><p>&nbsp;</p></td>
                <td><p>Total</p></td>
                <td class="border_column"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td class="border_column"><p>&nbsp;</p></td>
                <td class="border_column"><p>Contract</p></td>
                <td><p>Cash</p></td>
                <td class="border_column"><p>Death</p></td>
                <td><p>Cash</p></td>
                <td class="border_column"><p>Death</p></td>
                <td><p>Cash</p></td>
                <td class="border_column"><p>Death</p></td>
              </tr>
              <tr>
                <td class="border_column"><p>&nbsp;</p></td>
                <td class="border_column"><p>Premium</p></td>
                <td><p>Value</p></td>
                <td class="border_column"><p>Benefit</p></td>
                <td><p>Value</p></td>
                <td class="border_column"><p>Benefit</p></td>
                <td><p>Value</p></td>
                <td class="border_column"><p>Benefit</p></td>
              </tr>
              <tr height=17px class="odd-row">
                <td class="border_column"><p class="p-left">Year 5</p></td>
                <td class="border_column"><p>{{AnnualPremium5}}</p></td>
                <td><p>{{GuaranteedTotalCash5}}</p></td>
                <td class="border_column"><p>{{GuaranteedDeath5}}</p></td>
                <td><p>{{MidpointTotalCash5}}</p></td>
                <td class="border_column"><p>{{MidpointDeath5}}</p></td>
                <td><p>{{CurrentTotalCash5}}</p></td>
                <td class="border_column"><p>{{CurrentDeath5}}</p></td>
              </tr>
              <tr height=17px>
                <td class="border_column"><p class="p-left">Year 10</p></td>
                <td class="border_column"><p>{{AnnualPremium10}}</p></td>
                <td><p>{{GuaranteedTotalCash10}}</p></td>
                <td class="border_column"><p>{{GuaranteedDeath10}}</p></td>
                <td><p>{{MidpointTotalCash10}}</p></td>
                <td class="border_column"><p>{{MidpointDeath10}}</p></td>
                <td><p>{{CurrentTotalCash10}}</p></td>
                <td class="border_column"><p>{{CurrentDeath10}}</p></td>
              </tr>
              <tr height=17px class="odd-row">
                <td class="border_column"><p class="p-left">Year 20</p></td>
                <td class="border_column"><p>{{AnnualPremium20}}</p></td>
                <td><p>{{GuaranteedTotalCash20}}</p></td>
                <td class="border_column"><p>{{GuaranteedDeath20}}</p></td>
                <td><p>{{MidpointTotalCash20}}</p></td>
                <td class="border_column"><p>{{MidpointDeath20}}</p></td>
                <td><p>{{CurrentTotalCash20}}</p></td>
                <td class="border_column"><p>{{CurrentDeath20}}</p></td>
              </tr>
              <tr height=17px>
                <td class="border_column"><p class="p-left">Age 70</p></td>
                <td class="border_column"><p>{{AnnualPremium70}}</p></td>
                <td><p>{{GuaranteedTotalCash70}}</p></td>
                <td class="border_column"><p>{{GuaranteedDeath70}}</p></td>
                <td><p>{{MidpointTotalCash70}}</p></td>
                <td class="border_column"><p>{{MidpointDeath70}}</p></td>
                <td><p>{{CurrentTotalCash70}}</p></td>
                <td class="border_column"><p>{{CurrentDeath70}}</p></td>
              </tr>
          </table>
          <br>
        </div>`,
};

export const NumericRTRSummaryTableHtml = {
  Table: `
        <div>
            <table id="numeric_summary_table" class="full-width, p-right" cellspacing=0>
              <tr height=12px>
                <td colspan="4"></td>
                <td colspan="6" class="td-partial-border">
                  <p class="p-center">Non-Guaranteed Values</p>
                </td>
              </tr>
              <tr height=12px>
                <td colspan="2"></td>
                <td colspan="2" class="td-partial-border"><p class="p-center">Guaranteed Values</p></td>
                <td colspan="3" class="td-partial-border"><p class="p-center">Midpoint Assumptions</p></td>
                <td colspan="3" class="td-partial-border"><p class="p-center">Current Assumptions</p></td>
              </tr>
              <tr height=20px>
                <td class="border_column"><p>&nbsp;</p></td>
                <td class="border_column"><p>&nbsp;</p></td>
                <td colspan="2" class="border_column"><p>&nbsp;</p></td>
                <td colspan="3" class="border_column"><p>&nbsp;</p></td>
                <td colspan="3" class="border_column"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td class="border_column"><p>&nbsp;</p></td>
                <td class="border_column"><p>Contract</p></td>
                <td><p>Total</p></td>
                <td class="border_column"><p>&nbsp;</p></td>
                <td><p>&nbsp;</p></td>
                <td><p>Total</p></td>
                <td class="border_column"><p>&nbsp;</p></td>
                <td><p>&nbsp;</p></td>
                <td><p>Total</p></td>
                <td class="border_column"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td class="border_column"><p>&nbsp;</p></td>
                <td class="border_column"><p>Prem for</p></td>
                <td><p>Cash</p></td>
                <td class="border_column"><p>Death</p></td>
                <td><p>Contract</p></td>
                <td><p>Cash</p></td>
                <td class="border_column"><p>Death</p></td>
                <td><p>Contract</p></td>
                <td><p>Cash</p></td>
                <td class="border_column"><p>Death</p></td>
              </tr>
              <tr>
                <td class="border_column"><p>&nbsp;</p></td>
                <td class="border_column"><p>Gtd Values</p></td>
                <td><p>Value</p></td>
                <td class="border_column"><p>Benefit</p></td>
                <td><p>Premium</p></td>
                <td><p>Value</p></td>
                <td class="border_column"><p>Benefit</p></td>
                <td><p>Premium</p></td>
                <td><p>Value</p></td>
                <td class="border_column"><p>Benefit</p></td>
              </tr>
              <tr height=17px class="odd-row">
                <td class="border_column"><p class="p-left">Year 5</p></td>
                <td class="border_column"><p>{{AnnualPremium5}}</p></td>
                <td><p>{{GuaranteedTotalCash5}}</p></td>
                <td class="border_column"><p>{{GuaranteedDeath5}}</p></td>
                <td><p>{{MidpointContractPremium5}}</p></td>
                <td><p>{{MidpointTotalCash5}}</p></td>
                <td class="border_column"><p>{{MidpointDeath5}}</p></td>
                <td><p>{{CurrentContractPremium5}}</p></td>
                <td><p>{{CurrentTotalCash5}}</p></td>
                <td class="border_column"><p>{{CurrentDeath5}}</p></td>
              </tr>
              <tr height=17px>
                <td class="border_column"><p class="p-left">Year 10</p></td>
                <td class="border_column"><p>{{AnnualPremium10}}</p></td>
                <td><p>{{GuaranteedTotalCash10}}</p></td>
                <td class="border_column"><p>{{GuaranteedDeath10}}</p></td>
                <td><p>{{MidpointContractPremium10}}</p></td>
                <td><p>{{MidpointTotalCash10}}</p></td>
                <td class="border_column"><p>{{MidpointDeath10}}</p></td>
                <td><p>{{CurrentContractPremium10}}</p></td>
                <td><p>{{CurrentTotalCash10}}</p></td>
                <td class="border_column"><p>{{CurrentDeath10}}</p></td>
              </tr>
              <tr height=17px class="odd-row">
                <td class="border_column"><p class="p-left">Year 20</p></td>
                <td class="border_column"><p>{{AnnualPremium20}}</p></td>
                <td><p>{{GuaranteedTotalCash20}}</p></td>
                <td class="border_column"><p>{{GuaranteedDeath20}}</p></td>
                <td><p>{{MidpointContractPremium20}}</p></td>
                <td><p>{{MidpointTotalCash20}}</p></td>
                <td class="border_column"><p>{{MidpointDeath20}}</p></td>
                <td><p>{{CurrentContractPremium20}}</p></td>
                <td><p>{{CurrentTotalCash20}}</p></td>
                <td class="border_column"><p>{{CurrentDeath20}}</p></td>
              </tr>
              <tr height=17px>
                <td class="border_column"><p class="p-left">Age 70</p></td>
                <td class="border_column"><p>{{AnnualPremium70}}</p></td>
                <td><p>{{GuaranteedTotalCash70}}</p></td>
                <td class="border_column"><p>{{GuaranteedDeath70}}</p></td>
                <td><p>{{MidpointContractPremium70}}</p></td>
                <td><p>{{MidpointTotalCash70}}</p></td>
                <td class="border_column"><p>{{MidpointDeath70}}</p></td>
                <td><p>{{CurrentContractPremium70}}</p></td>
                <td><p>{{CurrentTotalCash70}}</p></td>
                <td class="border_column"><p>{{CurrentDeath70}}</p></td>
              </tr>
          </table>
          <br>
        </div>`,
};
